import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { compose } from "recompose";
import { withSnackbar } from "notistack";

import { GeoJSON, Pane } from "react-leaflet";

import { Radio } from "../../../services";
import { couleurZaDeploiement } from "../../../enums";
import MarkerRadioVN from "./MarkerRadioVN";

const ZaRadioVN = ({ codeReseau, optionSelectedConfigCarte, setIsLoading, enqueueSnackbar }) => {
  const [listeZaRadio, setListeZaRadio] = useState([]);
  const [positionMarkerRadio, setPositionMarkerRadio] = useState([49.2483009, 1.1748319999999999]);
  const [resetMarkerState, setResetMarkerState] = useState(false);

  const [abortRadio, setAbortRadio] = useState(new AbortController());

  const displayRadioVendee = async () => {
    abortRadio.abort();
    const abort = new AbortController();
    setAbortRadio(abort);

    Radio.getRadioZaByCodeRadio(codeReseau, abort)
      .then(responseRadio => {
        const listeZaRadioTemp = responseRadio.features.map(zaRadio => ({
          item: zaRadio,
          style: {
            color: couleurZaDeploiement.ZONE_RADIO,
            weight: 0.5,
            opacity: 1,
            fillColor: couleurZaDeploiement.ZONE_RADIO,
            dashArray: "0",
            fillOpacity: 0.6,
          },
        }));

        setListeZaRadio(listeZaRadioTemp);
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Set la position du marker cible sur la carte
  const onClickZaRadio = async e => {
    setResetMarkerState(!resetMarkerState);
    const targetPostion = [e.latlng.lat, e.latlng.lng];
    setPositionMarkerRadio(targetPostion);
  };

  useEffect(() => {
    displayRadioVendee();

    return () => {
      abortRadio.abort();
    };
  }, []);

  return (
    <>
      <Pane name="radio" className="leaflet-radio-pane">
        {optionSelectedConfigCarte.ZONE_RADIO &&
          listeZaRadio.length > 0 &&
          listeZaRadio.map(zaRadio => (
            <GeoJSON
              key={zaRadio.item.properties.CODEMARCHE}
              data={zaRadio.item}
              style={zaRadio.style}
              onClick={e => onClickZaRadio(e)}
            />
          ))}
      </Pane>
      {optionSelectedConfigCarte.ZONE_RADIO && listeZaRadio.length > 0 && (
        <MarkerRadioVN
          positionMarkerRadio={positionMarkerRadio}
          resetMarkerState={resetMarkerState}
        />
      )}
    </>
  );
};

ZaRadioVN.propTypes = {
  codeReseau: propTypes.string.isRequired,
  optionSelectedConfigCarte: propTypes.shape({
    LAYER_PLAN: propTypes.bool,
    LAYER_SAT: propTypes.bool,
    ALL_ZONES: propTypes.bool,
    SRO_DEP_201820: propTypes.bool,
    SRO_DEP_2021: propTypes.bool,
    SRO_DEP_2022: propTypes.bool,
    SRO_DEP_2023: propTypes.bool,
    SRO_OPEN: propTypes.bool,
    SRO_SOON: propTypes.bool,
    SRO_YEAR_N0: propTypes.bool,
    SRO_YEAR_N1: propTypes.bool,
    SRO_YEAR_N2: propTypes.bool,
    ZONE_RADIO: propTypes.bool,
    ZONE_AMII: propTypes.bool,
    ALL_STATUSES: propTypes.bool,
    IMB_RAC: propTypes.bool,
    IMB_ELIG: propTypes.bool,
    IMB_PROELIG: propTypes.bool,
    IMB_ETUDE: propTypes.bool,
    IMB_TRAVAUX_SECTEUR: propTypes.bool,
    IMB_TRAVAUX_RUE: propTypes.bool,
    IMB_DEMANDE: propTypes.bool,
    FTTE: propTypes.bool,
  }).isRequired,
  setIsLoading: propTypes.func.isRequired,
  enqueueSnackbar: propTypes.func.isRequired,
};

export default compose(withSnackbar)(ZaRadioVN);
